// extracted by mini-css-extract-plugin
export default {"header":"Sale_header__7Nhmp"};